import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {ValidateImeiResponse} from "../model/validateImeiResponse";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {ImeiInfo} from "../model/imeiInfo";
import {UpdateDevicesRequest} from "../model/updateDevicesRequest";
import {Region} from "../utils/RegionConstants";
import {IridiumValidationResponse} from "../model/iridiumValidationResponse";

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private http: HttpClient) { }

  validateImeis(imeis: string[], region: Region) : Observable<ValidateImeiResponse[]> {

    const params = new HttpParams()
      .set('imeis', imeis.join(','))
      .set('region', region);

    return this.http.get<ValidateImeiResponse[]>(
      `${environment.apiUrlPrefix}device/validate`,
      { params }
    );
  }

  validateIridiumImeis(imeis: string[]) : Observable<IridiumValidationResponse[]> {

    const params = new HttpParams()
      .set('imeis', imeis.join(','));

    return this.http.get<IridiumValidationResponse[]>(
      `${environment.apiUrlPrefix}device/validate/iridium`,
      { params }
    );
  }

  updateDevices(request: UpdateDevicesRequest[]) : Observable<ImeiInfo> {
    return this.http.patch<ImeiInfo>(environment.apiUrlPrefix + 'devices', request);
  }

  deleteDevices(imeiInfoIds: number[]) {
    return this.http.delete(environment.apiUrlPrefix + 'devices', {
      params: {
        imeiInfoIds: imeiInfoIds
      },
      observe: 'response'
    });
  }
}
